/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['.reference-brief-container[_ngcontent-%COMP%]{background-color:#fff;box-shadow:inset 0 .5px 0 0 #fff,0 1px 2px 0 #b3b3b3;padding:5px;margin-bottom:5px}.fa.success[_ngcontent-%COMP%]{color:#16a085}.fa.warning[_ngcontent-%COMP%]{color:#f39c12}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUvdHJhdmlzL2J1aWxkL2luc3BpcmVoZXAvcmVjb3JkLWVkaXRvci9zcmMvYXBwL3NoYXJlZC9jb21wb25lbnRzL3JlZmVyZW5jZS1icmllZi9yZWZlcmVuY2UtYnJpZWYuY29tcG9uZW50LnNjc3Muc2hpbS5uZ3N0eWxlLnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vaG9tZS90cmF2aXMvYnVpbGQvaW5zcGlyZWhlcC9yZWNvcmQtZWRpdG9yL3NyYy9hcHAvc2hhcmVkL2NvbXBvbmVudHMvcmVmZXJlbmNlLWJyaWVmL3JlZmVyZW5jZS1icmllZi5jb21wb25lbnQuc2NzcyJdLCJzb3VyY2VzQ29udGVudCI6WyIgIl0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7In0=



// WEBPACK FOOTER //
// /home/travis/build/inspirehep/record-editor/src/$$_gendir/app/shared/components/reference-brief/reference-brief.component.scss.shim.ngstyle.ts